import { render, staticRenderFns } from "./SoundSettingsButton.vue?vue&type=template&id=38c27cd6&scoped=true&"
import script from "./SoundSettingsButton.vue?vue&type=script&lang=js&"
export * from "./SoundSettingsButton.vue?vue&type=script&lang=js&"
import style0 from "./SoundSettingsButton.vue?vue&type=style&index=0&id=38c27cd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c27cd6",
  null
  
)

export default component.exports